module.exports = __webpack_public_path__ + "img/frame (6).c6195498.jpg";